import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import PropTypes from "prop-types";
import { FontWeight, QuicksandBold } from "components/Text/Text";
import { FiraSansBold, FiraSansExtraLight } from "components/Text/Text";
import { Breakpoints } from "constants/Breakpoints";


const propTypes = {
  isActive: PropTypes.bool,
  newBorder: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
  newBorder: false,
};

export const Value = styled.h3`
  color: #28975a;
`;

export const ValueWrap = styled.div`
  display: block;
  padding: 0px;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  padding-left: auto;
  padding-right: auto;
`;

export const MoneyValue = styled.h2`
  color: #f49a2d;
  font-weight: bold;
  margin-top: -10px;
`;

export const Subtitle = styled.h5`
  color: #bebebe;
  margin-top: -10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;


const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
  background-color:#FFF;  
`;


const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

const BorderSwitch = styled.div`
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

const CustomRectangle = styled.div`
  width: 45%;
  margin-left: 3%;
  height: 8em;
  margin-top: 0px;
  padding: 10px;
  margin-bottom: 0px;
  resize: none;
  cursor: auto;
  ${QuicksandBold};  
  color: ${Colors.WHITE};
  transition: box-shadow 0.15s ease;
  font-size: xx-small;
  font-weight: normal;
`;

const CustomRectanglePink = styled(CustomRectangle)`
  border: 1px none #ff7ebe;
  border-radius: 6px;
  background: rgb(255,126,190);
  background: linear-gradient(90deg, rgba(255,126,190,1) 60%, rgba(255,174,186,1) 100%);
  -webkit-box-shadow: 0px 10px 10px 0px rgba(255,126,190,0.34); 
  box-shadow: 0px 10px 10px 0px rgba(255,126,190,0.34);
`
const CustomRectangleGreen = styled(CustomRectangle)`
  border: 1px none #4cd964;
  border-radius: 6px;
  background: rgb(73,212,145);
  background: linear-gradient(90deg, rgba(73,212,145,1) 60%, rgba(135,241,131,1) 100%);
  -webkit-box-shadow: 0px 10px 10px 0px rgba(73,212,145,0.34); 
  box-shadow: 0px 10px 10px 0px rgba(73,212,145,0.34);
`

const TextArea = styled.textarea`
  width: 102%;
  height: 70px;
  border: 1px solid #888;
  border-radius: 8px;
  margin-left: -12px;
  margin-top: 0px;
  padding: 10px;
  margin-bottom: 0px;
  resize: none;
  cursor: auto;
  ${QuicksandBold};  
  color: ${Colors.GRAY[0]};
  transition: box-shadow 0.15s ease;

  outline: none;
  :focus {
    background: ${Colors.GRAY[5]}
    box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 0 3px ${Colors.SECONDARY};
  }
`;

export const SelectField = styled.select`
  width: 100%;
  position: relative;
  height: 42px;
  padding: 8px;
  border: solid 1px ${Colors.GRAY[3]};
  border-radius: 8px;
  background: white;
  font-size: 16px;
  color: ${Colors.GRAY[1]};
  outline: none;
  align-self: auto;
  box-sizing: border-box;
  text-align: initial;
  margin-bottom: 20px;
  ${QuicksandBold}

  transition: background 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${Colors.GRAY[3]};
  }

  &[disabled] {
    background-color: ${Colors.GRAY[4]};
    color: ${Colors.GRAY[0]};
  }
`;

const LayoutCircle = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;

  align-self: center;

  ${({ isActive }) =>
    isActive
      ? css`
      border: 1px solid ${Colors.GRAY[5]};
      background-color: ${Colors.GREEN};
      color: ${Colors.WHITE}
      box-shadow: 0px 3px 4px -2px rgba(0,0,0,0.75);
    `
      : ` border: 1px solid ${Colors.GREEN};
      background-color: ${Colors.WHITE};
      color: ${Colors.BLACK};
    `}
`;

const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 550px;
  padding: 10px 20px 10px 10px;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

const CircleBox = styled.div`
  margin-right: 10%;
  display: block;
  margin-top: 20px;
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: inline;
  }
`;

const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-family: "Quicksand";
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease, color 0.15s ease,
    width 0.3s ease, border 0.5s ease, border-color 0.5s ease,
    box-shadow 0.15s ease;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;
  color: #ffffff;
  background-color: #5c078c;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
`;


/* &::disabled {
  background-color: ${Colors.GRAY[4]};
  color: ${Colors.GRAY[0]};
} */

export {
  ButtonContainer,
  TextArea,
  LayoutCircle,
  Scrollbox,
  CircleBox,
  BorderSwitch,
  CalendarContainer,
  PlaceHolder,
  TagInput,
  ButtonContent,
  CustomRectanglePink,
  CustomRectangleGreen
};
